export enum ContactTypeEnum {
  NewContact = "New Contact",
  User = "User",
}


export enum SubscriberPatchModeEnum {
  ClientSnapShot = 'clientSnapShot'
}
